var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336.751,
    height: 319.748,
    viewBox: "0 0 336.751 319.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1114.028 308.004) rotate(150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.754,495.636a47.8,47.8,0,1,0,47.8,47.8,47.807,47.807,0,0,0-47.8-47.8",
    transform: "translate(175.397 0)",
    fill: "#f6d3d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.422,677.768a90.179,90.179,0,1,0-90.185-90.185,90.185,90.185,0,0,0,90.185,90.185",
    transform: "translate(0.001 22.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.014,506.568a27.051,27.051,0,1,0,27.052,27.051,27.052,27.052,0,0,0-27.052-27.051",
    transform: "translate(213.888 139.795)",
    fill: "#eb94a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.152fce80400350db3ae41c6e152f075e.svg";
export { ForwardRef as ReactComponent };